'use strict';
import $service from '../common/service/api-service'
import service from '../common/service/index.js';

function reLogin(res, args = {}) {
  res = res.code ? res : res.data;
  args.callback ? args.callback.call(this, res) : '';
}

export default {
  getEmailModel(context) {
    $service.post("/so/email-model/list")
      .then(res => {
        if (res && res.code === 1) {
          context.commit('setEmailModel', res.data)
        }
      })
  },
  identity(context, args = {}) {
    $service.post('/user/identity').then(res => {
      if (res.code == 1) {
        context.commit('setSession', res.data);
      }
      reLogin(res, args);
    })
  },
  identityPromise(context, args) {
    return service.requestPromise('/user/identity', {
      method: 'post'
    })
  },
  sendEmailVerifyCode(context, args) {
    console.log(args)
    return service.requestPromise('/user/sendEmailVerifyCode', {
      method: 'post',
      params: args
    })
  },
  changePassword(context, args) {
    return service.requestPromise('/user/password', {
      method: 'put',
      params: args
    })
  },
  sendLang(context, args = {}) {
    return service.requestPromise('/user/changeLang', {
      method: 'post',
      params: args
    })
  }
};



// WEBPACK FOOTER //
// ./src/store/action.js